import { ArrowRight, Loader2, MessageSquare, Plus } from 'lucide-react'
import { resolveConversationTitle } from '@/lib/conversations'
import { formatProjectDate, type ProjectConversation } from '@/pages/project/project-utils'

type ProjectChatsSectionProps = {
  loading: boolean
  contextMode: 'isolated' | 'space_shared'
  conversations: ProjectConversation[]
  onToggleContextMode: () => void
  onOpenNewChat: () => void
  onOpenConversation: (conversationId: string) => void
}

export function ProjectChatsSection({
  loading,
  contextMode,
  conversations,
  onToggleContextMode,
  onOpenNewChat,
  onOpenConversation,
}: ProjectChatsSectionProps) {
  return (
    <div className="glass-surface" style={{ padding: '12px', marginBottom: '10px' }}>
      <div className="flex items-center justify-between gap-2">
        <div>
          <p className="text-xs font-semibold">Чаты проекта</p>
          <p className="text-[10px] text-telegram-hint">Контекст: {contextMode === 'space_shared' ? 'Общий' : 'Изолированный'}</p>
        </div>
        <button
          onClick={onToggleContextMode}
          className="rounded-full glass-icon px-2 py-1 text-[10px] active:scale-95 transition-transform"
        >
          {contextMode === 'space_shared' ? 'Shared' : 'Isolated'}
        </button>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <button
          onClick={onOpenNewChat}
          className="rounded-xl bg-telegram-button text-white px-3 py-2 text-[11px] font-semibold flex items-center gap-1 active:scale-95 transition-transform"
        >
          <Plus size={12} />
          Новый чат проекта
        </button>
      </div>

      <div className="mt-2 flex flex-col gap-1">
        {loading ? (
          <p className="text-[11px] text-telegram-hint inline-flex items-center gap-1">
            <Loader2 size={11} className="animate-spin" />
            Загружаю чаты…
          </p>
        ) : conversations.length === 0 ? (
          <p className="text-[11px] text-telegram-hint">Чатов в проекте пока нет</p>
        ) : (
          conversations.slice(0, 12).map((conversation) => (
            <button
              key={conversation.id}
              onClick={() => onOpenConversation(conversation.id)}
              className="w-full text-left rounded-lg px-2 py-1.5 glass-icon active:scale-[0.99] transition-transform"
            >
              <div className="flex items-center gap-2">
                <MessageSquare size={12} className="text-telegram-hint shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-[11px] font-medium truncate">
                    {resolveConversationTitle(conversation.title, conversation.last_message, 'Новый чат')}
                  </p>
                  <p className="text-[10px] text-telegram-hint">
                    {conversation.message_count} сообщ. • {formatProjectDate(conversation.updated_at)}
                  </p>
                </div>
                <ArrowRight size={12} className="text-telegram-hint shrink-0" />
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  )
}
